import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { DataService } from '../data.service';

@Component({
    selector: 'app-googlemap',
    templateUrl: './googlemap.component.html',
    styleUrls: ['./googlemap.component.css']
})
export class GooglemapComponent implements OnInit {
    public arrData = new Array<any>();
    public arrTable = new Array<any>();
    public arrTable1 = new Array<any>();
    @Input() webpagedefinitionitemid: number;
    @Input() docid: number;
    @Input() webpagelayoutitemid: number;
    @Input() webpagethemeelementid: number;
    @Input() cache: boolean;
    public googlemapsapikey: string;
    public elementheight: number;

    @ViewChild('mapRef', { static: true }) mapElement: ElementRef;

    constructor(public dataservice: DataService) { }

    ngOnInit() {
        this.dataservice.getElementData(this.webpagedefinitionitemid, this.docid, this.webpagelayoutitemid, this.webpagethemeelementid, this.cache, 'g2/googlemap', (returndata: any) => {
            this.arrData = returndata;
            this.arrTable = returndata.Table;
            this.arrTable1 = returndata.Table1;
            this.googlemapsapikey = returndata.Table[0].googlemapsapikey;
            this.elementheight = returndata.Table[0].abslgheightinrows * returndata.Table[0].rowheightinpx;

            this.renderMap();
        }, '');
    }

    loadMap = () => {

        var styles = [
            {
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#bdbdbd"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dadada"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#a1dcd9"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            }
        ];

        var map = new window['google'].maps.Map(this.mapElement.nativeElement, {
            center: { lat: 46.1195648, lng: 14.8377050 },
            zoom: 13,
            styles: styles
        });

        //loop markers
        for (var table1 of this.arrTable1) {
            var geocode = table1.location.split(',');

            var position = new window['google'].maps.LatLng(geocode[0], geocode[1]);
            map.setCenter(position);

            var marker = new window['google'].maps.Marker({
                position: position,
                map: map,
                title: table1.mapaddress,
                draggable: true,
                animation: window['google'].maps.Animation.DROP,
                icon: { url: "/images/mappin.png" }
            });

            var contentString = table1.description;

            var infowindow = new window['google'].maps.InfoWindow({
                content: contentString
            });

            marker.addListener('click', function () {
                infowindow.open(map, marker);
            });
        }
    }

    renderMap() {
        window['initMap'] = () => {
            this.loadMap();
        }
        if (!window.document.getElementById('google-map-script')) {
            var s = window.document.createElement("script");
            s.id = "google-map-script";
            s.type = "text/javascript";
            s.src = "https://maps.googleapis.com/maps/api/js?key=" + this.googlemapsapikey + "&callback=initMap";

            window.document.body.appendChild(s);
        } else {
            this.loadMap();
        }
    }
}
